import React, { useEffect, useState } from 'react';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';

function Tutoriels() {
  const [size, setSize] = useState({ width: window.innerWidth, height: window.innerHeight });
  const isMobile = size.height > size.width;

  const handleWindowSizeChange = () => setSize({ width: window.innerWidth, height: window.innerHeight });

  useEffect(() => {
    handleWindowSizeChange();
    window.addEventListener('resize', handleWindowSizeChange);
    return () => window.removeEventListener('resize', handleWindowSizeChange);
  }, []);

  return (
    <Container maxWidth={false} className={isMobile ? 'conteneur-accueil-mobile' : 'conteneur-accueil'}>
      <Grid container spacing={5}>
        <Grid item xs={12}>
          <Paper className="paperFull">
            <ul><li><a href="http://syncstats.ddns.net/liens/Tutoriels/Assemblage/assemblage.mp4" target="_blank" rel="noopener noreferrer">Tutoriels</a></li></ul>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Tutoriels;



// WEBPACK FOOTER //
// src/components/Tutoriels.js